module.exports = "<span class=\"icon notification-icon ico-notifications\"></span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpNotificationIcon/adpNotificationIcon.html
// module id = 591
// module chunks = 0